if (typeof ProductQuantity !== 'function') {
  class ProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.attachListeners();
    }

    attachListeners() {
      const qtySelector = this.querySelector('.qty-selector');
      const qtyMinus = this.querySelector('.qty-minus');
      const qtyPlus = this.querySelector('.qty-plus');
      const qtyMin = qtySelector ? parseInt(qtySelector.getAttribute('min')) : 1;
      const qtyMax = qtySelector ? parseInt(qtySelector.getAttribute('max')) : 999;

      const preQtySelector = this.querySelector('.pre-qty-selector');
      const preQuantityOptions = this.querySelectorAll('.quantity-option');
      const preQtyDefaultValue = 6;

      // Initialize standard quantity selector
      if (qtySelector) {
        this.initStandardSelector(qtySelector, qtyMinus, qtyPlus, qtyMin, qtyMax);
      }

      // Initialize pre-quantity selector
      if (preQtySelector) {
        this.initPreQuantitySelector(preQtySelector, preQuantityOptions, preQtyDefaultValue);
      }
    }

    initStandardSelector(qtySelector, qtyMinus, qtyPlus, qtyMin, qtyMax) {
      this.updateQtyButtons(qtySelector, qtyMinus, qtyPlus, qtyMin, qtyMax);

      qtySelector.addEventListener('change', () =>
        this.updateQtyButtons(qtySelector, qtyMinus, qtyPlus, qtyMin, qtyMax)
      );

      qtyMinus.addEventListener('click', (e) => {
        e.preventDefault();
        if (!qtyMinus.classList.contains('disabled')) {
          qtySelector.value = Math.max(qtyMin, parseInt(qtySelector.value) - 1);
          this.updateQtyButtons(qtySelector, qtyMinus, qtyPlus, qtyMin, qtyMax);
        }
      });

      qtyPlus.addEventListener('click', (e) => {
        e.preventDefault();
        if (!qtyPlus.classList.contains('disabled')) {
          qtySelector.value = Math.min(qtyMax, parseInt(qtySelector.value) + 1);
          this.updateQtyButtons(qtySelector, qtyMinus, qtyPlus, qtyMin, qtyMax);
        }
      });
    }

    updateQtyButtons(qtySelector, qtyMinus, qtyPlus, qtyMin, qtyMax) {
      qtyMinus.classList.toggle('disabled', parseInt(qtySelector.value) <= qtyMin);
      qtyPlus.classList.toggle('disabled', parseInt(qtySelector.value) >= qtyMax);
    }

    initPreQuantitySelector(preQtySelector, preQuantityOptions, preQtyDefaultValue) {
      preQtySelector.value = preQtyDefaultValue;
      preQuantityOptions.forEach((option) => {
        const container = option.closest('.quantity-container');
        option.addEventListener('click', () =>
          this.handlePreQuantitySelection(preQtySelector, container, preQuantityOptions)
        );
      });
    }

    handlePreQuantitySelection(preQtySelector, selectedContainer, options) {
      options.forEach((option) => {
        const container = option.closest('.quantity-container');
        container.querySelector('.quantity-option').classList.remove('selected');
        container.querySelector('.selected-label').classList.remove('selected');
      });

      selectedContainer.querySelector('.quantity-option').classList.add('selected');
      selectedContainer.querySelector('.selected-label').classList.add('selected');

      if (preQtySelector) {
        preQtySelector.value = selectedContainer.querySelector('.quantity-option').dataset.quantity;
      }
    }
  }

  if (typeof customElements.get('product-quantity') === 'undefined') {
    customElements.define('product-quantity', ProductQuantity);
  }
}
